import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"

export default class extends Controller {

  static targets = ["qrContainer", "qrToggler"]

  initialize() {
    this.log("initialized")
  }

  connect(){
    this.log("connected")
  }

  toggleQR() {
    if(this.data.get("showingQr") == "true"){
      this.hideQR();
    } else {
      this.showQR();
    }

    this.data.set("showingQr",!(this.data.get("showingQr") == "true"))
  }

  hideQR() {
    this.log("hidding qr")
    const qrElements = this.qrContainerTarget.querySelectorAll("[data-passport-qr]")

    qrElements.forEach(element => {
      if (element.parentNode === this.qrContainerTarget) {
        this.qrContainerTarget.removeChild(element)
      }
    })

    this.qrContainerTarget.removeAttribute("title")
  }

  async showQR() {
    this.log("showing qr")

    const containerStyle = window.getComputedStyle(this.qrContainerTarget)
    const height = parseInt(containerStyle.height, 10)
    const width = parseInt(containerStyle.width, 10)

    // Limpia cualquier QR previo generado por este controlador
    const existingElements = this.qrContainerTarget.querySelectorAll("[data-passport-qr]")
    existingElements.forEach(element => {
      if (element.parentNode === this.qrContainerTarget) {
        this.qrContainerTarget.removeChild(element)
      }
    })

    const canvas = document.createElement("canvas")
    canvas.width = width
    canvas.height = height
    canvas.dataset.passportQr = "true"
    this.qrContainerTarget.appendChild(canvas)

    try {
      await QRCode.toCanvas(canvas, this.data.get("qrContent"), {
        width,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff",
        },
      })
    } catch (error) {
      this.log("error generating qr: " + error)
      if (canvas.parentNode === this.qrContainerTarget) {
        this.qrContainerTarget.removeChild(canvas)
      }
    }
  }

  log(msg){
    console.log("[passport] "+msg)
  }

}
